export default __webpack_public_path__ + "static/media/Group 6505@3x.fb1076ac.png";